<template>
    <b-container fluid>
        <b-row class="d-flex justify-content-end" v-if="isDebug">
            <b-col sm="2">
                <b-form-group class="mb-0">
                    <b-form-select plain v-model="assistantId" :options="asisstantOptions" size="sm">
                        <template v-slot:first>
                            <b-form-select-option :value="null">select assistant</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="8" offset-lg="2">
                <FormulateForm name="ai-assistant" v-model="formValues">
                    <form-wizard title="" subtitle="" :start-index="index" ref="wizard" @on-complete="onComplete"
                        color="#EA1674" finishButtonText="Open in editor">
                        <tab-content title="Use case" ref="tab" icon="ri-folder-line">
                            <iq-card>
                                <template v-slot:headerTitle>
                                    <h4 class="card-title">Choose use case</h4>
                                </template>
                                <template v-slot:body>
                                    <b-row>
                                        <b-col v-for="option in useCaseOptions" :key="option.value" sm="4">
                                            <label class="card--option" :disabled="option.disabled">
                                                <input type="radio" name="useCaseId" :value="option.value"
                                                    v-model="formValues.useCaseId" />
                                                <iq-card :checked="formValues.useCaseId === option.value">
                                                    <template v-slot:body>
                                                        <div class="text-center">
                                                            <h5>{{ option.value }}</h5>
                                                        </div>
                                                    </template>
                                                </iq-card>
                                            </label><br>
                                        </b-col>
                                    </b-row>
                                </template>
                            </iq-card>
                        </tab-content>
                        <tab-content title="Tactics" icon="ri-guide-fill">
                            <iq-card>
                                <template v-slot:headerTitle>
                                    <h4 class="card-title">Choose tactic</h4>
                                </template>
                                <template v-slot:body>
                                    <b-row>
                                        <b-col v-for="option in tacticOptions" :key="option.value" sm="4">
                                            <label class="card--option" :disabled="option.disabled">
                                                <input type="radio" name="tacticId" :value="option.value"
                                                    v-model="formValues.tacticId" />
                                                <iq-card :checked="formValues.tacticId === option.value">
                                                    <template v-slot:body>
                                                        <div class="text-center">
                                                            <h5>{{ option.value }}</h5>
                                                        </div>
                                                    </template>
                                                </iq-card>
                                            </label><br>
                                        </b-col>
                                    </b-row>
                                </template>
                            </iq-card>
                        </tab-content>
                        <tab-content title="Generate data" icon="ri-file-list-line">
                            <iq-card :no-header="true">
                                <!-- <template v-slot:headerTitle>
                                    <h4 class="card-title">AI data generator</h4>
                                </template> -->
                                <template v-slot:body>
                                    <b-row v-if="showPrompt">
                                        <b-col>
                                            <b-form-group label="Prompt" label-for="exampleFormControlTextarea1">
                                                <b-form-textarea id="exampleFormControlTextarea1" :rows="promptRows"
                                                    v-model="prompt" style="line-height: 26px;">
                                                </b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="text-right">
                                            <b-button variant="light" @click="toggleShowPrompt">{{ togglePromptLabel
                                                }}</b-button>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <p class="text-center">Click "Generate data" button.</p>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="text-center">
                                            <b-button @click="generateData" variant="primary" size="lg"
                                                style="font-size: 2rem; margin: 1rem;">
                                                Generate data
                                                <b-spinner label="Spinning" v-if="loading" size="sm"></b-spinner>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="error">
                                        <b-col>
                                            <b-alert :show="true" variant="alert" class="text-white bg-danger mb-0">
                                                <div class="iq-alert-icon">
                                                    <i class="ri-alert-line"></i>
                                                </div>
                                                <div class="iq-alert-text">Failed to generate data: {{ error }}. Please
                                                    try again.</div>
                                            </b-alert>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="result">
                                        <b-col>
                                            <b-row>
                                                <b-col>
                                                    <h3>Results</h3>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    <dl class="row">
                                                        <template v-for="(value, key) in result" @key="key">
                                                            <dt class="col-sm-3">{{ key }}</dt>
                                                            <dd class="col-sm-9">{{ value }}</dd>
                                                        </template>
                                                    </dl>
                                                </b-col>
                                            </b-row>

                                        </b-col>
                                    </b-row>
                                </template>
                            </iq-card>
                        </tab-content>
                    </form-wizard>
                </FormulateForm>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard';
import { core } from "../../config/pluginInit";
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import { sendPrompt, generatePrompt, useCases, emailTemplateJSON, utf8ToBase64, fetchAssistants, defaultAiAssistantId } from '../../ai-assistant';
import Mustache from 'mustache';
import { accessToken, parseJwt } from "../../Utils/auth";
import gql from "graphql-tag";
import { isDebug } from "../../Utils/account";
const ROOT_ORGANIZATION = gql`
  query rootOrganization($id: uuid!) {
    organizations_by_pk(id: $id) {
      id
      name
      metadata
    }
  }
`;

let wizardLeftButton;
let wizardPrevButton;
let wizardRightButton;
let wizardNextButton;

function generateRandomHash() {
    const array = new Uint8Array(8); // Array of 16 random bytes
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => ('0' + byte.toString(16)).slice(-2)).join('');
}

export default {
    name: 'AIAssistant',
    data() {
        return {
            formValues: {
                useCaseId: "",
                tacticId: "",
            },
            index: 0,
            prompt: "",
            result: null,
            loading: false,
            promptRows: 30,
            showPrompt: false,
            error: null,
            asisstantOptions: [],
            assistantId: "",
            isDebug: isDebug()
        }
    },
    components: {
        FormWizard, TabContent
    },
    mounted() {
        core.index()
        wizardLeftButton = document.getElementsByClassName('wizard-footer-left')
        wizardRightButton = document.getElementsByClassName('wizard-footer-right')
        const wizard = document.getElementsByClassName('wizard-btn')
        // wizard.forEach((value) => {
        //     value.classList.add('d-none')
        // })
        this.initAssistantOptions();
        
    },
    apollo: {
        rootOrganization: {
            query: ROOT_ORGANIZATION,
            variables() {
                const parsedJWT = parseJwt(accessToken());
                const id = parsedJWT['https://hasura.io/jwt/claims']?.['x-hasura-organization-id']
                return { id };
            },
            update: data => {
                return data.organizations_by_pk
            }
        }
    },
    methods: {
        async generateData() {
            this.result = null;
            this.loading = true;
            this.error = null;
            try {
                const result = await sendPrompt(this.prompt, this.assistantId);
                this.result = result;
            } catch (error) {
                this.error = error.message;
            }
            this.loading = false;
        },
        async initAssistantOptions() {
            const assistants = await fetchAssistants();            
            this.asisstantOptions = assistants.map(i => ({
                value: i.id, text: i.name
            }));
            this.assistantId = defaultAiAssistantId;
            // TODO: when proper communication, update this to load by name
            // const rex = new RegExp(`email`);
            // const rex = new RegExp(`omnibot v0.b`);
            // const emailAssistant = this.asisstantOptions.find(i => rex.test(i.text.toLowerCase()));
            // if (emailAssistant) {
            //     this.assistantId = emailAssistant.value;
            // } else {
            //     // DEFAULT
            //     this.assistantId = this.asisstantOptions[0]?.value;
            // }
            
        },
        redirectToEditor() {
            const stringifiedTpl = JSON.stringify(emailTemplateJSON);
            const dataForTemplate = {
                ...this.result,
                organization: {
                    metadata: {
                        ...this.rootOrganization?.metadata
                    },
                    footerEmail: "{{ email }}",
                    footerUnsubscribeLink: "{{ unsubscribe_link }}"
                },
            };
            const renderedTpl = Mustache.render(stringifiedTpl, dataForTemplate);
            const sanitizedTpl = renderedTpl.replaceAll("\n", "\\n"); 
            const base64Tpl = utf8ToBase64(sanitizedTpl);
            const dataId = generateRandomHash();
            localStorage.setItem(dataId, base64Tpl);

            window.open(`/templates/create?editorDataId=${dataId}`, '_blank');
        },
        nextTab() {
            wizardNextButton = wizardRightButton[0].getElementsByClassName('wizard-btn')
            wizardNextButton[0].click()
            // setTimeout(() => {
            //     const wizard = document.getElementsByClassName('wizard-btn')
            //     wizard.forEach((value) => {
            //         value.classList.add('d-none')
            //     })
            // }, 20)
        },
        prevTab() {
            wizardPrevButton = wizardLeftButton[0].getElementsByClassName('wizard-btn')
            wizardPrevButton[0].click()
            // const wizard = document.getElementsByClassName('wizard-btn')
            // wizard.forEach((value) => {
            //     value.classList.add('d-none')
            // })
        },
        onComplete() {
            this.redirectToEditor();
        },
        toggleShowPrompt() {
            this.showPrompt = !this.showPrompt;
        }
    },
    computed: {
        useCaseOptions() {
            return useCases.map(i => ({ value: i.name, label: i.name, disabled: i.disabled }));
        },
        tacticOptions() {
            return useCases.find(i => i.name === this.formValues.useCaseId)?.tactics.map(i => ({ value: i.name, label: i.name, disabled: i.disabled }));
        },
        togglePromptLabel() {
            if (!this.showPrompt) {
                return "show prompt"
            } else {
                return "hide prompt"
            }
        },
    },
    watch: {
        formValues(newVal) {
            const { tacticId, useCaseId } = newVal;
            const organizationMetadata = this.rootOrganization?.metadata;
            const organizationName = this.rootOrganization?.name;
            if (useCaseId && tacticId) {
                this.prompt = generatePrompt({ useCaseName: useCaseId, tacticName: tacticId, organizationName, organizationMetadata })
            }
        },
    }
}
</script>
<style scoped>
.wizard-btn {
    border-radius: 15px;
}

.textarea-prompt {
    line-height: 26px;
}

.card--option {
    display: block !important;
}

.card--option[disabled=disabled] {
    opacity: 0.3;
    pointer-events: none;
}

.card--option .iq-card {
    box-shadow: 0px 0px 12px 0px rgba(120, 146, 141, 0.16);
    margin-bottom: 0;
}

.card--option .iq-card:hover {
    cursor: pointer;
    box-shadow: 0px 0px 12px 0px rgba(234, 22, 116, 0.36);
}

.card--option .iq-card[checked=checked] {
    background: linear-gradient(to right, var(--iq-primary) 0%, var(--iq-primary-light) 100%);
    color: white !important;
}

.card--option .iq-card[checked=checked] h5 {
    color: white;
}

.card--option input {
    display: none;
}

.card--option .iq-card {
    height: 90px;
    display: flex;
    align-items: center;
}
</style>